<template>
  <v-dialog v-model="isVisible" max-width="600px" persistent>
    <v-card class="cb-card">
      <card-title :title="isEditMode ? 'Editar cuenta' : 'Añadir cuenta'" />

      <v-card-text>
        <v-container>
          <v-alert v-if="isEditMode" class="error white--text">
            Solo se editarán los campos que no estén vacíos
          </v-alert>

          <v-row>
            <v-col cols="12">
              <span>Nombre de la cuenta</span>
              <v-text-field
                v-model="formData.name"
                :placeholder="isEditMode ? 'Sin editar' : 'Requerido*'"
                :rules="nameRules"
                dense
                hide-details
                outlined
                required
              />
            </v-col>

            <v-col cols="12">
              <span>Usuario API</span>
              <v-text-field
                v-model="formData.user"
                :placeholder="isEditMode ? 'Sin editar' : 'Requerido*'"
                :rules="userRules"
                dense
                hide-details
                outlined
                required
              />
            </v-col>

            <v-col cols="12">
              <span>Contraseña API</span>
              <v-text-field
                v-model="formData.password"
                :append-icon="showPassword ? 'visibility' : 'visibility_off'"
                :placeholder="isEditMode ? 'Sin editar' : 'Requerido*'"
                :rules="passwordRules"
                :type="showPassword ? 'text' : 'password'"
                dense
                hide-details
                outlined
                required
                @click:append="showPassword = !showPassword"
              />
            </v-col>

            <v-col cols="12">
              <span>Proveedor</span>
              <v-select
                v-model="formData.provider"
                :items="providers"
                :placeholder="isEditMode ? 'Sin editar' : 'Requerido*'"
                :rules="providerRules"
                dense
                hide-details
                outlined
                required
              />
            </v-col>

            <v-col cols="12">
              <span>Plataforma</span>
              <v-select
                v-model="formData.platform"
                :items="platforms"
                :placeholder="isEditMode ? 'Sin editar' : 'Requerido*'"
                :rules="platformRules"
                dense
                hide-details
                outlined
                required
              />
            </v-col>

            <v-col cols="12">
              <span>Descripción</span>
              <v-textarea
                v-model="formData.description"
                :placeholder="isEditMode ? 'Sin editar' : 'Requerido*'"
                dense
                hide-details
                outlined
                rows="3"
              />
            </v-col>
          </v-row>

          <small class="grey--text">* Campos requeridos</small>
        </v-container>
      </v-card-text>

      <v-card-actions class="cb-row-contrast_low pa-4">
        <v-row justify="space-between">
          <button-icon-text-model-b
            color="error"
            text="Cancelar"
            @click="handleCancel"
          />

          <button-icon-text-model-b
            :disabled="!isFormValid"
            :text="isEditMode ? 'Actualizar' : 'Guardar'"
            color="primary"
            @click="handleSave"
          />
        </v-row>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import ButtonIconTextModelB from "@/components/repository/buttons/ButtonIconTextModelB.vue";
import CardTitle from "@/components/repository/cards/CardTitle.vue";

const DEFAULT_ACCOUNT_DATA = {
  name: "",
  user: "",
  password: "",
  provider: "Mailjet",
  description: "",
  platform: "CertySign"
};

export default {
  name: "AccountDialog",
  components: {
    ButtonIconTextModelB,
    CardTitle
  },
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    isEditMode: {
      type: Boolean,
      default: false
    },
    accountData: {
      type: Object,
      default: () => ({ ...DEFAULT_ACCOUNT_DATA })
    }
  },
  data() {
    return {
      formData: { ...this.accountData },
      showPassword: false,
      platforms: ["CertySign", "Communicalia"],
      providers: ["Mailjet", "SES"],
      nameRules: [v => !!v || 'El nombre es requerido'],
      userRules: [v => !!v || 'El usuario es requerido'],
      passwordRules: [v => !!v || 'La contraseña es requerida'],
      providerRules: [v => !!v || 'El proveedor es requerido'],
      platformRules: [v => !!v || 'La plataforma es requerida']
    };
  },
  computed: {
    isVisible: {
      get() {
        return this.visible;
      },
      set(value) {
        this.$emit('update:visible', value);
      }
    },
    isFormValid() {
      if (this.isEditMode) return true;

      return !!(
        this.formData.name &&
        this.formData.user &&
        this.formData.password &&
        this.formData.provider &&
        this.formData.platform
      );
    }
  },
  watch: {
    accountData: {
      handler(val) {
        this.formData = { ...val };
      },
      deep: true
    }
  },
  methods: {
    handleCancel() {
      this.resetForm();
      this.$emit('cancel');
    },
    handleSave() {
      if (!this.isFormValid) return;

      this.$emit('save', { ...this.formData });
      this.resetForm();
    },
    resetForm() {
      this.formData = { ...DEFAULT_ACCOUNT_DATA };
      this.showPassword = false;
    }
  }
};
</script>
